export default __webpack_public_path__ + "static/logo-19aaf507ada9ac7fd4581f135cc1388e.svg";